module.exports = __webpack_public_path__ + "3bbb61bbed381429dbb7c41d0cc33e2c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-22.png
// module id = 3147
// module chunks = 0